/* ================================================================
   TARASHE — Contact Page JS
   File: assets/tarashe-contact.js
================================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Scroll animations ── */
  function initAnimations() {
    var els = document.querySelectorAll('[data-tc-animate]');
    if (!els.length) return;
    if (reduced) { els.forEach(function(el){ el.classList.add('tc-visible'); }); return; }
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('tc-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.10, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el){ obs.observe(el); });
  }

  /* ── FAQ Accordion ── */
  function initFAQ() {
    var triggers = document.querySelectorAll('.tc-faq__trigger');
    triggers.forEach(function(trigger) {
      var panelId = trigger.getAttribute('aria-controls');
      var panel   = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;
      trigger.addEventListener('click', function() {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        /* Close all */
        triggers.forEach(function(t) {
          t.setAttribute('aria-expanded', 'false');
          var pid = t.getAttribute('aria-controls');
          var p = pid ? document.getElementById(pid) : null;
          if (p) p.classList.remove('is-open');
        });
        /* Toggle current */
        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-open');
        }
      });
    });
  }

  /* ── Form floating label fix (for autofill) ── */
  function initFloatingLabels() {
    var inputs = document.querySelectorAll('.tc-input, .tc-textarea');
    inputs.forEach(function(input) {
      /* Check on load in case browser pre-filled */
      function check() {
        if (input.value) {
          input.classList.add('tc-has-value');
        } else {
          input.classList.remove('tc-has-value');
        }
      }
      input.addEventListener('input', check);
      input.addEventListener('change', check);
      /* Interval for autofill detection */
      var timer = setInterval(function() {
        if (input.matches(':-webkit-autofill') || input.value) {
          input.classList.add('tc-has-value');
        }
        clearInterval(timer);
      }, 600);
    });
  }

  /* ── Success / error scroll ── */
  function initFormStatus() {
    var status = document.querySelector('.tc-form-status');
    if (status) {
      setTimeout(function() {
        status.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 200);
    }
  }

  function init() {
    initAnimations();
    initFAQ();
    initFloatingLabels();
    initFormStatus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelector('.tc-page')) init();
  });
})();